import React from 'react';
import ScrollPositionManager from './components/ScrollPositionManager';

import { SwitchTransition } from 'react-transition-group'
//import { useLocation } from 'react-router';

import Fade from '@material-ui/core/Fade';
import Slide from '@material-ui/core/Slide';
import SharedDialogContext from './SharedDialogContext';

export default function SharedDialogRenderer(props) {
  const dialog = React.useContext(SharedDialogContext);
  //const location = useLocation();

  const dialogComponent = dialog ? React.createElement(dialog.component, dialog.dialogProps) : null;
  const modal = Boolean(dialog && !dialog.fullScreen);
  const fullScreen = Boolean(dialog && dialog.fullScreen);

  return (
    <React.Fragment>
      { modal ? dialogComponent : null }
      <SwitchTransition component={null}>
        { fullScreen && dialog.dialogProps.open ? 
          <Slide direction="up" 
            timeout={{enter:375, exit: 195}} 
            onExited={dialog.dialogProps.onExited} 
            mountOnEnter
            unmountOnExit
            key="dialog">
            <div>
            { dialogComponent }
            </div>
          </Slide> : props.children }
      </SwitchTransition>
    </React.Fragment>
    );
};